import * as React from "react";

import { Colors } from "@blueprintjs/core";

const outerRingThickness = 8;

interface Props {
	percentage: number;
	radius: number;
	overTime: boolean;
	dark: boolean;
}
export default class Circle extends React.Component<Props, {}> {
	private getCoordinatesForPercent = (percent2: number) => {
		const x =
			Math.cos(2 * Math.PI * percent2 - Math.PI / 2) * (this.props.radius - outerRingThickness) +
			this.props.radius;
		const y =
			Math.sin(2 * Math.PI * percent2 - Math.PI / 2) * (this.props.radius - outerRingThickness) +
			this.props.radius;

		return [x, y];
	};
	public render() {
		const gray1 = this.props.dark ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY3;
		const gray2 = this.props.dark ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5;

		const endX: number = this.getCoordinatesForPercent(this.props.percentage)[0];
		const endY: number = this.getCoordinatesForPercent(this.props.percentage)[1];

		const largeArcFlag = Math.round(this.props.percentage) - this.props.percentage > 0 ? 1 : 0;
		const primaryPath = `M${this.props.radius},${this.props.radius}  L${
			this.props.radius
		},${outerRingThickness}  A${this.props.radius - outerRingThickness},${this.props.radius -
			outerRingThickness} 0 ${largeArcFlag},1 ${endX},${endY} z`;
		const secondaryPath = `M${this.props.radius},${this.props.radius}  L${
			this.props.radius
		},${outerRingThickness}  A${this.props.radius - outerRingThickness},${this.props.radius -
			outerRingThickness} 0 ${+!largeArcFlag},0 ${endX},${endY} z`;
		const primaryColor = this.props.overTime ? Colors.RED2 : gray1;
		const secondaryColor = this.props.overTime ? gray1 : gray2;
		return (
			<div>
				<svg
					width={2 * this.props.radius + "px"}
					height={2 * this.props.radius + "px"}
					viewBox={"0 0 " + 2 * this.props.radius + " " + 2 * this.props.radius}
				>
					<circle
						cx={this.props.radius}
						cy={this.props.radius}
						r={this.props.radius - (outerRingThickness + 1) / 2}
						fill="transparent"
						stroke={gray1}
						strokeWidth={outerRingThickness}
					/>

					<path d={primaryPath} fill={primaryColor} />
					<path d={secondaryPath} fill={secondaryColor} />
				</svg>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/Circle.tsx